import React from "react";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import Tabs from "../../../../Components/Common/Tabs";
import { studentTutoringTabsData } from "../../../../data/SidebarData";
import { Loader } from "../../../../Components/Common/Loader";
import { Link, useLocation } from "react-router-dom";
import Accordion from "../../../Home/Components/Accordion";
import { useAuth } from "../../../../Context/AuthContext";
import QueryString from "qs";
import useSWR from "swr";
import { orderUrls } from "../../../../Api/Auth/ApiUrls";
import { publicUrls, studentUrls } from "../../../../Api/Auth/AppUrls";
import Button from "../../../../Components/Common/Button";
import { checkStudentRouteVisibility } from "../../../../utils/findStudentRouteBySlug";
import NotFound from "../../../Notfound";

const StudentTutoringIndexMechanical = () => {
  const { userData, categoryData } = useAuth();
  const location = useLocation();
  const isVisibleCivil = checkStudentRouteVisibility(
    categoryData,
    studentUrls.studentTutoring
  );
  const isVisibleMechanical = checkStudentRouteVisibility(
    categoryData,
    studentUrls.studentTutoringMechanical
  );
  const visibleTabs = studentTutoringTabsData.filter((tab) => {
    if (!tab?.path) return true;
    if (tab.path === studentUrls.studentTutoring && !isVisibleCivil) return false;
    if (tab.path === studentUrls.studentTutoringMechanical && !isVisibleMechanical)
      return false;
    return true;
  });
  const parts = location.pathname.split("/").filter(Boolean);
  const dynamicPath = `/${parts[0]}/${parts[1]}-${parts[2]}`;
  const dynamicSlug = dynamicPath.split("/")[dynamicPath.split("/").length - 1];

  const apiQueryParams = {
    userId: userData?._id,
    itemType: "package",
    slug: dynamicSlug,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);
  const { isLoading, data } = useSWR(orderUrls.purchases(apiQueryString));

  const dataRender = data?.data?.map((item, index) => ({
    title: item?.package?.title,
    content: (
      <div className="flex flex-col gap-3" key={index}>
        <span className="font-normal text-sm capitalize">
          Status : {item?.packageStatus}
        </span>
        <span className="font-medium text-sm capitalize">
          {item?.packageStatus === "pending"
            ? "You will be contacted soon by us for one to one tutoring"
            : item?.packageStatus === "contacted"
            ? "You have been contacted by us for one to one tutoring"
            : "One to one tutoring package is completed"}
        </span>
      </div>
    ),
  }));

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={visibleTabs} />
      {!isVisibleMechanical ? (
        <NotFound />
      ) : (
        <>
          {isLoading ? (
            <Loader />
          ) : data?.data?.length === 0 ? (
            <span className=" mt-2 flex flex-col justify-center gap-2 text-center items-center">
              No available content. Purchase tutoring package to get started.
              <Link to={publicUrls.tutoringMechanical}>
                <Button>Tutoring</Button>
              </Link>
            </span>
          ) : (
            <Accordion accordionData={dataRender} fullWidth openFirst />
          )}
        </>
      )}
    </div>
  );
};

export default StudentTutoringIndexMechanical;
